import {
  AnnotationMapIcon,
  FolderIcon,
  GanModelIcon,
  GridIcon,
  HomeIcon,
  ServerIcon,
  ServiceIcon,
  SettingsIcon,
  VolumeIcon,
  WorkspaceIcon,
} from '@assets/icons';
import { Stack } from '@mui/material';
import { useOrganizationContext } from '@navigation/OrganizationContext';
import { navigate } from 'gatsby';
import { NavDivider } from './NavDivider';
import { SideNavButton } from './SideNavButton';

export const OrganizationNav = ({ selectedTab }: { selectedTab: string }) => {
  const { organizationId, organization } = useOrganizationContext();
  if (!organizationId || !organization) {
    return null;
  }
  const { serviceOnly } = organization;

  if (serviceOnly) {
    return (
      <Stack sx={{ width: '100%' }}>
        <SideNavButton
          Icon={HomeIcon}
          onClick={() => navigate(`/${organizationId}`)}
          label="Home"
          selected={selectedTab === 'home'}
        />
        <SideNavButton
          Icon={WorkspaceIcon}
          onClick={() => navigate(`/${organizationId}/workspaces`)}
          label="Workspaces"
          selected={selectedTab === 'workspaces'}
        />
        <SideNavButton
          Icon={ServerIcon}
          onClick={() => navigate(`/${organizationId}/servers`)}
          label="Servers"
          selected={selectedTab === 'servers'}
        />
        <SideNavButton
          Icon={FolderIcon}
          onClick={() => navigate(`/${organizationId}/resources`)}
          label="Agent resources"
          selected={selectedTab === 'resources'}
        />
        <SideNavButton
          Icon={GridIcon}
          onClick={() => navigate(`/${organizationId}/examples`)}
          label="Examples"
          selected={selectedTab === 'examples'}
        />
        <SideNavButton
          Icon={SettingsIcon}
          onClick={() => navigate(`/${organizationId}/settings`)}
          label="Settings"
          selected={selectedTab === 'settings'}
        />
      </Stack>
    );
  }

  return (
    <Stack sx={{ width: '100%' }}>
      <SideNavButton
        Icon={GridIcon}
        onClick={() => navigate(`/${organizationId}/sample-gallery`)}
        label="Sample gallery"
        selected={selectedTab === 'sample-gallery'}
      />
      <NavDivider />
      <SideNavButton
        Icon={HomeIcon}
        onClick={() => navigate(`/${organizationId}`)}
        label="Home"
        selected={selectedTab === 'home'}
      />
      <SideNavButton
        Icon={ServerIcon}
        onClick={() => navigate(`/${organizationId}/remote-sessions`)}
        label="Remote sessions"
        selected={selectedTab === 'remote-sessions'}
      />
      <SideNavButton
        Icon={ServiceIcon}
        onClick={() => navigate(`/${organizationId}/channels`)}
        label="Channels"
        selected={selectedTab === 'channels'}
      />
      <SideNavButton
        Icon={VolumeIcon}
        onClick={() => navigate(`/${organizationId}/volumes`)}
        label="Volumes"
        selected={selectedTab === 'volumes'}
      />
      <SideNavButton
        Icon={GanModelIcon}
        onClick={() => navigate(`/${organizationId}/gan-models`)}
        label="GAN models"
        selected={selectedTab === 'gan-models'}
      />
      <SideNavButton
        Icon={AnnotationMapIcon}
        onClick={() => navigate(`/${organizationId}/annotation-maps`)}
        label="Annotation maps"
        selected={selectedTab === 'annotation-maps'}
      />
      <SideNavButton
        Icon={SettingsIcon}
        onClick={() => navigate(`/${organizationId}/settings`)}
        label="Settings"
        selected={selectedTab === 'settings'}
      />
    </Stack>
  );
};
